const ITEMS = [
  "PLA+ ENGINEERING POLYMERS",
  "UV-STABLE OUTDOOR RESINS",
  "NEODYMIUM N52 MAGNETS",
  "CUSTOM FACILITY BRANDING",
  "ON-DEMAND PRODUCTION",
  "DOMESTIC FULFILLMENT",
  "INDOOR + OUTDOOR RATED",
  "VOLUME PRICING TIERS",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="bg-[#0A0A0A] text-white border-y border-[#0A0A0A] overflow-hidden"
    >
      <div className="flex bb-ticker whitespace-nowrap py-4">
        {row.map((t, i) => (
          <div key={i} className="flex items-center gap-10 pr-10">
            <span className="font-mono-bb text-[11px] tracking-[0.25em]">{t}</span>
            <span className="w-1.5 h-1.5 bg-[#DFFF00] inline-block" />
          </div>
        ))}
      </div>
    </div>
  );
}
